/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/detailed',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '收入统计',
      icon: 'component',
    },
    children: [
      {
        path: '/detailed/detailedList',
        component: () => import('@/myviews/AG_statisticalReport/detailed/detailedList'),
        alwaysShow: false,
        name: '收支明细',
        meta: {
          title: '收支明细',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/detailed/doctorPerformance',
        component: () => import('@/myviews/AG_statisticalReport/doctorPerformance/doctorPerformance'),
        alwaysShow: false,
        name: '医生业绩统计',
        meta: {
          title: '医生业绩统计',
          icon: 'peoples',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/detailed/salesPerformance',
        component: () => import('@/myviews/AG_statisticalReport/salesPerformance/salesPerformance'),
        alwaysShow: false,
        name: '销售业绩统计',
        meta: {
          title: '销售业绩统计',
          icon: 'table',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        }
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/nurseManage/AG_statisticalReport.js